// #/services/registry/zodFromJson/zodSchemasFromActionDetails.ts

import { ActionDetails } from '#/types/registry';
import { zodSchemaFromJsonSchema } from './zodSchemaFromJsonSchema';

export function zodSchemasFromActionDetails(actionDetails: ActionDetails) {
  try {
    console.info(
      `zodSchemasFromActionDetails(actionDetails: ${JSON.stringify(
        actionDetails,
      )}`,
    );

    let inputPathParamsZodSchema;
    let inputQueryParamsZodSchema;
    let inputBodyJsonParamsZodSchema;
    let outputSuccessResponseBodyJsonZodSchema;

    try {
      console.debug(
        `[zodSchemasFromActionDetails] actionDetails?.inputSchema?.path: ${JSON.stringify(
          actionDetails?.inputSchema?.path,
          null,
          2,
        )}`,
      );
      inputPathParamsZodSchema = zodSchemaFromJsonSchema(
        actionDetails?.inputSchema?.path,
      );
    } catch (error) {
      console.debug({ label: 'inputPathParamsZodSchema', error });
      // console.error(error);
    }

    try {
      inputQueryParamsZodSchema = zodSchemaFromJsonSchema(
        actionDetails.inputSchema.query,
      );
    } catch (error) {
      console.debug({ label: 'inputQueryParamsZodSchema', error });
      // console.error(error);
    }

    try {
      inputBodyJsonParamsZodSchema = zodSchemaFromJsonSchema(
        actionDetails.inputSchema.bodyJson,
      );
    } catch (error) {
      console.debug({ label: 'inputBodyJsonParamsZodSchema', error });
      // console.error(error);
    }

    try {
      outputSuccessResponseBodyJsonZodSchema = zodSchemaFromJsonSchema(
        actionDetails.outputSchema,
      );
    } catch (error) {
      console.debug({
        label: 'outputSuccessResponseBodyJsonZodSchema',
        error,
      });
      // console.error(error);
    }

    // console.debug({
    //   inputPathParamsZodSchema,
    //   inputQueryParamsZodSchema,
    //   inputBodyJsonParamsZodSchema,
    //   outputSuccessResponseBodyJsonZodSchema,
    // });

    return {
      inputSchema: {
        path: inputPathParamsZodSchema,
        query: inputQueryParamsZodSchema,
        bodyJson: inputBodyJsonParamsZodSchema,
      },
      outputSchema: outputSuccessResponseBodyJsonZodSchema,
    };
  } catch (err) {
    console.error(
      `Error parsing zod schemas from action details ${actionDetails.serviceKey} ${actionDetails.actionKey}: ${err}`,
    );
  }
}
